
$(document).ready(function () {
const variantDataElement = document.getElementById("variant-data");
let allVariants = [];

if (variantDataElement) {
  try {
    allVariants = JSON.parse(variantDataElement.textContent);
  } catch (error) {
    console.error("Error parsing variant data:", error);
  }
}

const imagePositions = allVariants
  .filter(v => v.featured_media)
  .map(v => ({
    id: v.id,
    position: v.featured_media.position,
    src: v.featured_media.src
  }));


function getImagePositionByDataValue(dataValue) {
  const match = imagePositions.find(v => v.id == dataValue);
  if (match) {
    console.log(`Image position for variant ID ${dataValue}:`, match.position);
    return match.position;
  } else {
    console.warn(`No image found for variant ID ${dataValue}`);
    return null;
  }
}

  function findImagePosition(value) {
    for (const row of allvariants) {
      if (row.option1 === value) {
        return row.imagepoistion;
      }
    }
    return null;
  }
  
  function triggerClickOnImagePosition(imagePosition) {
    const thumbs = document.querySelectorAll(".main-product__slider.product-thumb-slider .main-product__slider-media .main-product__slider-image");
    if (thumbs && thumbs[imagePosition - 1]) {
      thumbs[imagePosition - 1].click();
    }
  }

  function findVariantObj(option1, option2, option3) {
    return allvariants.find(item => item.option1 === option1 && item.option2 === option2 && item.option3 === option3);
  }

  function checkSelections3() {
    const errorDisplay = document.querySelector('.custom-multioptions-form-errors');
    const atcButton = document.querySelector('.custom-atc-basket');

    let selectedOption1 = null; // Declare the variable outside the blocks

if (document.querySelector('input[type="radio"][name="option-1"]:checked')) {
  selectedOption1 = document.querySelector('input[type="radio"][name="option-1"]:checked');
} else if(document.querySelector('input[type="radio"][name="option-colour"]:checked')) {
  selectedOption1 = document.querySelector('input[type="radio"][name="option-colour"]:checked');
}

    const selectedOption2 = document.querySelector('.select_ul.option-2 .selected');
    const selectedOption3 = document.querySelector('.select_ul.option-3 .selected');
    const firstSelectedOption = document.querySelector('.select_ul.option-1 .selected');

    errorDisplay.innerHTML = "";
    if (selectedOption1 && selectedOption2 && selectedOption3) {
      const colourValue = selectedOption1.getAttribute('data-value_handle');
      const sizeValue = selectedOption2.getAttribute('data-value-handle2');
      const thirdOptionValue = selectedOption3.getAttribute('data-value-handle2');
      const variantObj = findVariantObj(colourValue, sizeValue, thirdOptionValue);
      if (variantObj) {
        const {
          variantid,
          price,
          includevat,
          partnumber
        } = variantObj;
       
        document.querySelector('.v-partnumber').textContent = partnumber;
        //console.log('partnumber nocustom custom pdp', partnumber, variantid);
        //document.querySelector('.priceexcl').innerHTML = includevat;
        atcButton.setAttribute('data-variant_id', variantid);
         
        
      }
    } else if (selectedOption1 && selectedOption2) {
      const colourValue = selectedOption1.getAttribute('data-value_handle');
      const sizeValue = selectedOption2.getAttribute('data-value-handle2');
      console.log('colourValue', colourValue, 'sizeValue', sizeValue);
      const variantObj = findVariantObj(colourValue, sizeValue, '');
      if (variantObj) {
        const {
          variantid,
          price,
          includevat,
          partnumber
        } = variantObj;
        
        document.querySelector('.v-partnumber').textContent = partnumber;
        //console.log('partnumber nocustom custom pdp', partnumber, variantid);
        //document.querySelector('.priceexcl').innerHTML = includevat;
        atcButton.setAttribute('data-variant_id', variantid);
        
      }
    } else if (selectedOption1) {
      const colourValue = selectedOption1.getAttribute('data-value_handle');
      const variantObj = findVariantObj(colourValue, '', '');
      if (variantObj) {
        const {
          variantid,
          price,
          includevat,
          partnumber
        } = variantObj;
        //document.getElementById('product-price').innerHTML = price;
        document.querySelector('.v-partnumber').textContent = partnumber;
        //console.log('partnumber266 cusrtom pdp', partnumber, variantid);
        //document.querySelector('.priceexcl').innerHTML = includevat;
        atcButton.setAttribute('data-variant_id', variantid);
        
      }
    } else if (firstSelectedOption && selectedOption2) {
      const sizeValue2 = selectedOption2.getAttribute('data-value-handle2');
      const sizeValue = firstSelectedOption.getAttribute('data-value-handle2');
      const variantObj = findVariantObj(sizeValue, sizeValue2, '');
      console.log('variantObj', variantObj);
      if (variantObj) {
        const {
          variantid,
          price,
          includevat,
          partnumber
        } = variantObj;
        //document.getElementById('product-price').innerHTML = price;
        document.querySelector('.v-partnumber').textContent = partnumber;
        //console.log('partnumber266 cusrtom pdp', partnumber, variantid);
        //document.querySelector('.priceexcl').innerHTML = includevat;
        atcButton.setAttribute('data-variant_id', variantid);
        
      }
    } else if (firstSelectedOption) {
      const sizeValue = firstSelectedOption.getAttribute('data-value-handle2');
      const variantObj = findVariantObj(sizeValue, '', '');
      if (variantObj) {
        const {
          variantid,
          price,
          includevat,
          partnumber
        } = variantObj;
        //document.getElementById('product-price').innerHTML = price;
        document.querySelector('.v-partnumber').textContent = partnumber;
        //console.log('partnumber266 cusrtom pdp', partnumber, variantid);
        //document.querySelector('.priceexcl').innerHTML = includevat;
        atcButton.setAttribute('data-variant_id', variantid);
        
      }
    }
  }


  let productNavSlider = $(".product-nav-slider");
  let productThumbSlider = $(".product-thumb-slider");

  if ((productNavSlider.length > 0 && !productNavSlider.hasClass("slick-initialized")) && (productThumbSlider.length > 0 && !productThumbSlider.hasClass("slick-initialized"))) {
    productNavSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      draggable: false,
      infinite: false,
      swipe: true, // Optional: Disable swipe as well
      touchMove: true, // Prevent touch dragging
      asNavFor: ".product-thumb-slider",
    });

    productThumbSlider.slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: ".product-nav-slider",
      arrows: true,
      dots: false,
      focusOnSelect: true,
      infinite: false,
      draggable: false,
      swipe: true, // Optional: Disable swipe as well
      touchMove: true, // Prevent touch dragging
      prevArrow:
        '<button type="button" class="prev-arrow"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 1L1 7L7 13" stroke="#222329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:
        '<button type="button" class="next-arrow"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 13L7 7L1 1" stroke="#222329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    });
  }

  $(window).on("resize", function () {
    setTimeout(productThumbSlider, 500); // Delay to prevent conflicts
    setTimeout(productNavSlider, 500); // Delay to prevent conflicts
  });
  

  $(".custom__select .default_option").click(function(){
    $(this).parent().toggleClass("active");
  })

  
   $(document).on("click",".custom__select .select_ul li",function() {
    const variants = JSON.parse(document.getElementById('variant-data').textContent);
    var currentele = $(this).html();
    $(this).siblings().removeClass('selected');
    $(this).addClass('selected');
    $(this).parent().parent().find('.default_option').html(currentele);
    $(this).parents(".custom__select").removeClass("active");
    
     const selectedSize1 = $(this).attr('data-value'); // Option 2 value
    
     const selectedColor1 = $('input[name="option-colour"]:checked').val(); // Option 1 value
   

  // Update Option 3 dropdown based on selected Option 1 & 2
   const opt3sizeList1 = document.querySelector('.select_ul.option-3');
   const opt3seenSizess = {};
   const currencySymbol = window.cartCurrency && window.cartCurrency.symbol ? window.cartCurrency.symbol : '£';
   const opt3avaible = document.querySelector('.select_ul.option-3');
   const $li = $(this);
   const $parentUl = $li.closest('.select_ul');

  // ✅ Skip logic if this is inside `.option-3`
  
    // custom size deselect all
    const accordionTitle = document.querySelector('.accordian-container .accordian-title');
    const accordionContent = document.querySelector('.accordian-container .accordian-content');
    if (accordionContent) {
      fadeOut(accordionContent);
      $('.custom__size-wrapper .size_swatch_contaner .swatch-element input').prop('checked', false);
      $('.custom__size-wrapper .custom-length-area #enterlength').val('');
      $('.custom__size-wrapper .custom-length-area .display-price-area').hide();

      $('.pdp-unlock__savings').show();
    }
    if (accordionTitle) {
      accordionTitle.classList.remove('open');
    }

    // image change code
    // let variantHandle = $(this).attr('data-value-handle2');
    // const imagePosition = findImagePosition(variantHandle);
    // if (imagePosition !== null) {
    //   triggerClickOnImagePosition(imagePosition);
    // }
    

    let variantID = Number($(this).attr('data-variant-id'));
   
    //let variantPrice = $(this).attr('data-variant-price');
    // let variantPrice = $(this).find('.size__price-text').attr('data-price');
    let variantPrice = $(this).attr('data-price');
     
    $('.custom-atc-basket').attr('data-variant_id', variantID);
  
    $('.pdp-unlock__savings-table .pdp-table__row').hide();
    $('.pdp-unlock__savings-table .pdp-table__row.pdp-table__row-heading').show();

    if ($(`.pdp-unlock__savings-table .pdp-table__row[data-variant="${variantID}"]`).length > 0) {
      $('.pdp-unlock__savings').show();
      $(`.pdp-unlock__savings-table .pdp-table__row[data-variant="${variantID}"]`).show();
    } else {
      $('.pdp-unlock__savings').hide();
    }
    console.log('variantID', variantID);
    const $rows = $(`.pdp-unlock__savings-table .js-pdp-table__row-heading[data-variant="${variantID}"]`);

    if ($rows.length > 0) {
      $('.pdp-unlock__savings-table .js-pdp-table__row-heading').hide();
      $rows.show();
    } else {
      $('.pdp-unlock__savings-table .js-pdp-table__row-heading').css('display', 'none');
    }
    
    if (typeof variantPrice === 'undefined') {
      $('.product__price-text').text($(this).attr('data-variant-price'));
    }else{
      $('.product__price-text').text(variantPrice);
    }
  //  checkSelections3();
    const checkedInput = document.querySelector('.js_radio_change:checked');
    if (checkedInput) {
      checkedInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  setTimeout(function() {
      var imagePosVarId = $('.custom-atc-basket').attr('data-variant_id');
      let newVariantId = $li.attr('data-new-var-id');
       
      var imagePosition1 = getImagePositionByDataValue(newVariantId);
      console.log('imagePosition1 ' + newVariantId)
      if (imagePosition1 !== null) {
          triggerClickOnImagePosition(imagePosition1);
        }
        }, 2000);
   
    // const checkedInput = document.querySelector('input[name="option-colour"]:checked');
    // if (checkedInput) {
    //   checkedInput.dispatchEvent(new Event('change', { bubbles: true }));
    // }

    

    
    
    if ($parentUl.hasClass('option-3')) {
    console.log('Clicked inside option-3 list, skipping...');
    return;
  }
  if(opt3sizeList1){
    opt3sizeList1.querySelectorAll('li').forEach(li => {
    const opt3sizeValue1 = li.getAttribute('data-value');
    console.log('opt3sizeValue1 ' + opt3sizeValue1)
    if (!opt3sizeValue1 || opt3sizeValue1.includes('Custom Length')) {
      li.style.display = 'none';
      return;
    }

    const matchedVariant = variants.find(v =>
      v.option1 === selectedColor1 &&
      v.option2 === selectedSize1 &&
      v.option3 === opt3sizeValue1 &&
      v.available &&
      !opt3seenSizess[v.option3]
    );

    if (matchedVariant) {
      opt3seenSizess[matchedVariant.option3] = true;

      const basePrice = matchedVariant.price / 100;
      const isVatEnabled = $('.js_vat_price').attr('data-vat-check') === "true";
      const vatPrice = isVatEnabled ? basePrice * 1.2 : basePrice;
      const formattedPrice = `${currencySymbol}${(isVatEnabled ? vatPrice : basePrice).toFixed(2)}`;

      li.setAttribute('data-price', formattedPrice);
      li.setAttribute('data-variant-title', matchedVariant.title || '');

      const priceSpan = li.querySelector('.size__price-text');
      if (priceSpan) {
        priceSpan.textContent = isVatEnabled
          ? `${formattedPrice} Inc. VAT`
          : `${currencySymbol}${basePrice.toFixed(2)} + VAT`;
      }

      const sizeSpan = li.querySelector('.size__text');
      if (sizeSpan) {
        let cleanedText = opt3sizeValue1.split('(')[0].trim();
        sizeSpan.textContent = cleanedText;
      }

      li.style.display = '';
    } else {
      li.style.display = 'none';
    }
  });
  }
    })

  // ✅ Only open/close logic


  $(document).on("click", ".worktop_material_custom__select .select_ul li", function () {
  const currentele = $(this).html();
    console.log('clicked item worktop material');
  // Set selected item
  $(this).siblings().removeClass("selected");
  $(this).addClass("selected");

  // Update default display text
  $(this).closest(".worktop_material_custom__select")
         .find(".default_option")
         .html(currentele);

  // Close dropdown
  $(this).closest(".worktop_material_custom__select").removeClass("active");
  let proVariantId = $(this).attr('data-price');
     
    $('.pdp-unlock__savings-table .pdp-table__row').hide();
    $('.pdp-unlock__savings-table .pdp-table__row.pdp-table__row-heading').show();

    if ($(`.pdp-unlock__savings-table .pdp-table__row[data-variant="${proVariantId}"]`).length > 0) {
      $('.pdp-unlock__savings').show();
      $(`.pdp-unlock__savings-table .pdp-table__row[data-variant="${proVariantId}"]`).show();
    } else {
      $('.pdp-unlock__savings').hide();
    }
    
    const $rows = $(`.pdp-unlock__savings-table .js-pdp-table__row-heading[data-variant="${proVariantId}"]`);

    if ($rows.length > 0) {
      $('.pdp-unlock__savings-table .js-pdp-table__row-heading').hide();
      $rows.show();
    } else {
      $('.pdp-unlock__savings-table .js-pdp-table__row-heading').css('display', 'none');
    }
  
});

// ✅ Toggle open on default click
$(document).on("click", ".worktop_material_custom__select .default_option", function () {
 $(this).parent().toggleClass("active");
});


 
  

  $('.accordion__header').click(function (e) {
    // Close all open contents
    $(this).parent().siblings().removeClass('active');
    $(this).parent().toggleClass("active");
    $('.accordion__content').slideUp();
    // Toggle the current section
    const content = $(this).next('.accordion__content');
    if (!content.is(':visible')) {
      content.slideDown();
    }
  });

    $('.accordion__header-default').click(function (e) {
    // Close all open contents
    $(this).parent().siblings().removeClass('active');
    $(this).parent().toggleClass("active");
    $('.accordion__content-default').slideUp();
    // Toggle the current section
    const content = $(this).next('.accordion__content-default');
    if (!content.is(':visible')) {
      content.slideDown();
    }
  });


  let trustedLogo = $(".trusted-logo__slider");

  if (trustedLogo.length > 0  && !trustedLogo.hasClass("slick-initialized")) {
    trustedLogo.slick({
      dots: false,
      arrows: false,
      slidesToShow: 5,
      infinite: true,
      lazyLoad: "progressive",
      speed: 3000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: "linear",
      draggable: false,
      swipe: false,
      touchMove: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      swipeToSlide: false,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            speed: 8000,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2,
            speed: 3000,
          },
        },
      ],
    });
  }

  let customerReviews = $(".our-customer__slider");

  if (customerReviews.length > 0 && !customerReviews.hasClass("slick-initialized")) {
    customerReviews.slick({
      dots: false,
      arrows: true,
      slidesToShow: 3,
      infinite: true,
      lazyLoad: "progressive",
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 1000,
      centerMode: true,
      centerPadding: "250px",
      responsive: [
        {
          breakpoint: 1380,
          settings: {
            slidesToShow: 3,
            centerPadding: "150px",
          },
        },
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: "0",
          },
        }
      ],
    });
  }

  
  let customerBought = $(".js-customer-bought-slider");

  if (customerBought.length > 0 && !customerBought.hasClass("slick-initialized")) {
    customerBought.slick({
      dots: false,
      arrows: true,
      slidesToShow: 4,
      infinite: true,
      lazyLoad: "progressive",
      speed: 800,
      centerMode: true,
      centerPadding: "50px",
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        }, 
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            centerPadding: "150px",
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            centerPadding: "100px",
          },
        }
      ],
    });
  }

  $(".custom-mats-product__video-play").click(function () {
    // Hide the banner
    $(this).parent().hide();

    const videoSrc = $("#youtubeVideo").attr("src") + "&autoplay=1";
    $("#youtubeVideo").attr("src", videoSrc);

    // Show the video container
    $("#videoContainer").css("display", "block");

    // Get the original src, add autoplay, and set it back
  });


  // pdp accordion description read more
  // if ($('.readmore__text').length > 0) {
  //   $(document).on('click', '.readmore__text', function (e) {
  //     e.preventDefault();
      
  //     const $content = $(this).parent().find('.description__content');
  //     const contentHeight = $content.get(0).scrollHeight; // Get the full height of the content
  //     const currentHeight = $content.height(); // Current height of the content

  //     if (currentHeight < contentHeight) {
  //       // If content is collapsed, animate to show full content
  //       $content.stop().animate({ height: contentHeight }, 500); // Expand to full height
  //       $(this).text('Read Less');
  //     } else {
  //       // If content is expanded, animate to show only a portion
  //       $content.stop().animate({ height: 100 }, 500); // Collapse to a smaller height (e.g., 100px)
  //       $(this).text('Read More');
  //     }
  //   });
  // }

  if ($('.readmore__text').length > 0) {
    $('body').on('click', '.readmore__text', function (e) {
      e.preventDefault();

      const $content = $(this).parent().find('.description__content');
      const contentHeight = $content.get(0).scrollHeight; // Full content height
      const currentHeight = $content.height(); // Current height of the content

      const contentPosition = $content.offset().top; // Position of the content block relative to the page

      if (currentHeight < contentHeight) {
        // If content is collapsed, animate to show full content
        $content.stop().animate({ height: contentHeight }, 500);

        $('html, body').animate({
          scrollTop: contentPosition
        }, 500);

        $(this).text('Read Less');
      } else {
        $content.stop().animate({ height: 100 }, 500);

        // Simultaneously scroll the page up to the content position
        $('html, body').animate({
          scrollTop: contentPosition - 100
        }, 500);

        $(this).text('Read More');
      }

    });

    $('.description__content').stop().animate({ height: 100 }, 500);

  }

});